// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__wKgc0","brand":"Nav_brand__NwPsv"};